__webpack_require__.p = "https://assets.mydeal.com.au/seller_portal/react/";